/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S2_Li1Inputs */

const tr_servis_s2_li1 = /** @type {(inputs: Servis_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik, Platform üzerinde ilan edilen planlardan (Başlangıç, Profesyonel, Kurumsal) seçilerek başlatılır.`)
};

const en_servis_s2_li1 = /** @type {(inputs: Servis_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription is started by selecting one of the plans announced on the Platform (Başlangıç, Profesyonel, Kurumsal).`)
};

const de_servis_s2_li1 = /** @type {(inputs: Servis_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Abonnement wird durch Auswahl eines der auf der Plattform veröffentlichten Pläne (Başlangıç, Profesyonel, Kurumsal) gestartet.`)
};

const ru_servis_s2_li1 = /** @type {(inputs: Servis_S2_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписка начинается с выбора одного из планов, объявленных на Платформе (Başlangıç, Profesyonel, Kurumsal).`)
};

/**
* | output |
* | --- |
* | "The subscription is started by selecting one of the plans announced on the Platform (Başlangıç, Profesyonel, Kurumsal)." |
*
* @param {Servis_S2_Li1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s2_li1 = /** @type {((inputs?: Servis_S2_Li1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S2_Li1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s2_li1(inputs)
	if (locale === "de") return de_servis_s2_li1(inputs)
	if (locale === "ru") return ru_servis_s2_li1(inputs)
	return tr_servis_s2_li1(inputs)
});